export default __webpack_public_path__ + "static/media/ico-smart_btnBack.ea3ae8cd.svg";